import { NextPage } from 'next'
import React from 'react'
import { useRecoilValue } from 'recoil'

import { Grid, GridItem } from '@hub/grid'
import { H3 } from '@hub/heading'
import {
  CarMediumIcon,
  UserMediumIcon,
  ShoppingCartMediumIcon,
  NotificationMediumIcon,
} from '@hub/icon'
import useIsMounted from '@scentregroup/shared/hooks/use-is-mounted'

import InfoPageTile from '../components/info-page-tile'
import AccountLayout from '../components/layouts/account-layout'
import SpinnerDelayed from '../components/spinner-delayed'
import withRequiresSession from '../components/with-requires-session'
import { userAtom } from '../lib/atoms/user-info'
import { incBase, ORDERS, PARKING, PREFERENCES, PROFILE } from '../lib/paths'

const infoPageData = [
  {
    title: 'Profile',
    icon: UserMediumIcon,
    link: incBase(`/${PROFILE}`),
    description: 'Contact details and name',
  },
  {
    title: 'Orders',
    icon: ShoppingCartMediumIcon,
    link: incBase(`/${ORDERS}`),
    description: 'Past online orders',
  },
  {
    title: 'Parking',
    icon: CarMediumIcon,
    link: incBase(`/${PARKING}`),
    description: 'Review saved number plates',
  },
  {
    title: 'Preferences',
    icon: NotificationMediumIcon,
    link: incBase(`/${PREFERENCES}`),
    description: 'Marketing and notifications',
  },
]

const Page: NextPage = () => {
  const { data } = useRecoilValue(userAtom)

  const firstName = data?.firstName || ''
  const userHasMarketplaceOrders = data?.hasMarketplaceOrders || false
  const isBrowser = useIsMounted()

  return (
    <AccountLayout pageId={'dashboard-page'} maxWidth={'size-max-fixed'}>
      <H3 sx={{ marginBottom: 'spacing-md' }}>
        Welcome{firstName && `, ${firstName}`}
      </H3>
      {isBrowser ? (
        <Grid templateColumns={'repeat(3, 1fr)'} gap={'1px'}>
          {infoPageData
            .filter(
              item =>
                (item.title.toLowerCase() === 'orders' &&
                  userHasMarketplaceOrders) ||
                !['orders'].includes(item.title.toLowerCase())
            )
            .map(item => (
              <GridItem
                colSpan={[3, 3, 1]}
                sx={{
                  outline: '1px solid',
                  outlineColor: 'ghost',
                  _hover: { bg: 'smoke' },
                }}
                key={item.title}
              >
                <InfoPageTile
                  title={item.title}
                  Icon={item.icon}
                  link={item.link}
                  description={item.description}
                />
              </GridItem>
            ))}
        </Grid>
      ) : (
        <SpinnerDelayed />
      )}
    </AccountLayout>
  )
}

export default withRequiresSession(Page)
